import React, { Suspense } from 'react';
import NextFetch, { FetchProps } from './fetch';

export default function Render({ loader, ...rest }: FetchProps & { loader: React.ReactNode }) {
  return (
    <Suspense fallback={loader || null}>
      <NextFetch {...rest} />
    </Suspense>
  );
}
